import { call, put, takeLatest } from 'redux-saga/effects';
import * as apollo from 'apollo/notes.query';
import { uploadImage as uploadFile } from 'api/image';
import * as types from './types';

function* getNote(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.getCurrentNote, payload.id);
    if (!response.errors) {
      yield put({ type: types.GET_NOTE_SUCCESS, payload: response.data.note });
    } else {
      yield put({ type: types.GET_NOTE_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.GET_NOTE_FAIL });
  }
};

function* getNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.getCurrentNoteTemplate, payload.id);
    if (!response.errors) {
      yield put({ type: types.GET_TEMPLATE_SUCCESS, payload: response.data.noteTemplate });
    } else {
      yield put({ type: types.GET_TEMPLATE_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.GET_TEMPLATE_FAIL });
  }
};

function* blockNote(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.blockingWeddingNote, payload.id);
    if (!response.errors) {
      yield put({ type: types.BLOCK_NOTE_SUCCESS, payload: response.blockingWeddingNote });
    } else {
      yield put({ type: types.BLOCK_NOTE_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.BLOCK_NOTE_FAIL });
  }
};

function* unBlockNote(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.unblockingWeddingNote, payload.id);
    if (!response.errors) {
      yield put({ type: types.UNBLOCK_NOTE_SUCCESS, payload: response.unblockingWeddingNote });
    } else {
      yield put({ type: types.UNBLOCK_NOTE_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.UNBLOCK_NOTE_FAIL });
  }
};

function* getNoteBlockedStatus(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.getNoteBlockedStatus, payload.id);
    if (!response.errors) {
      yield put({ type: types.GET_NOTE_BLOCKED_STATUS_SUCCESS, payload: response.unblockingWeddingNote });
    } else {
      yield put({ type: types.GET_NOTE_BLOCKED_STATUS_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.UNBLOCK_NOTE_FAIL });
  }
};

function* restrictionsNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.restrictionsNote, payload);
    yield put({ type: types.RESTRICTIONS_NOTE_SUCCESS, payload: response.restrictionsNote.output });
  } catch (err) {
    yield put({ type: types.RESTRICTIONS_NOTE_FAIL });
  }
}

function* fileUpload(action) {
  const { payload } = action || {};
  const { file, filename, noteId, isTemplate } = payload;

  try {
    const fileResponse = yield call(apollo.createWeddingNoteFile, { noteId, filename, isTemplate });
    if (!fileResponse.errors) {
      const fileData = fileResponse?.data?.createWeddingNoteFile;
      if (fileData) {
        const { key } = fileData.file;
        const url = fileData.form.action;
        const { fields } = fileData.form;
        const { status } = yield call(uploadFile, url, fields, file);
        if (status === 204) {
          const confirmReponse = yield call(apollo.confirmWeddingNoteFileUpload, { key });
          if (confirmReponse.data.confirmWeddingNoteFileUpload) {
            yield put({ type: types.NOTE_FILE_UPLOAD_SUCCESS });
            return;
          }
        }
      }
    }
    yield put({ type: types.NOTE_FILE_UPLOAD_FAIL });
  } catch (err) {
    yield put({ type: types.NOTE_FILE_UPLOAD_FAIL });
  }
};

function* fileRemove(action) {
  const { payload } = action || {};
  const { id } = payload;

  try {
    const fileResponse = yield call(apollo.deleteWeddingNoteFile, id);
    if (!fileResponse.errors) {
      yield put({ type: types.NOTE_FILE_REMOVE_SUCCESS });
      return;
    }
    yield put({ type: types.NOTE_FILE_REMOVE_FAIL });
  } catch (err) {
    yield put({ type: types.NOTE_FILE_REMOVE_FAIL });
  }
};

function* templateFileRemove(action) {
  const { payload } = action || {};
  const { id } = payload;

  try {
    const fileResponse = yield call(apollo.deleteTemplateNoteFile, id);
    if (!fileResponse.errors) {
      yield put({ type: types.NOTE_TEMPLATE_FILE_REMOVE_SUCCESS });
      return;
    }
    yield put({ type: types.NOTE_TEMPLATE_FILE_REMOVE_FAIL });
  } catch (err) {
    yield put({ type: types.NOTE_TEMPLATE_FILE_REMOVE_FAIL });
  }
}

function* createNote() {
  try {
    yield put({ type: types.CREATE_NOTE_SUCCESS, payload: {} });
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_FAIL });
  }
}

function* updateSingleNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateNote, payload);
    if (response.error) {
      yield put({ type: types.UPDATE_NOTE_FAIL, payload: response.error });
    }
    yield put({ type: types.UPDATE_NOTE_SUCCESS, payload: response?.updateNote?.note });
  } catch (err) {
    yield put({
      type: types.UPDATE_NOTE_FAIL,
      payload: {
        message: 'Your work was not saved. Please refresh and try again.',
      },
    });
  }
}

function* updateNoteContent(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateNoteContent, payload);
    if (response.error) {
      yield put({ type: types.UPDATE_NOTE_CONTENT_FAIL, payload: response.error });
    }

    yield put({ type: types.UPDATE_NOTE_CONTENT_SUCCESS, payload: response?.updateNoteContent });
  } catch (err) {
    yield put({ type: types.UPDATE_NOTE_FAIL , payload: {
      message: 'Your note could not be saved. Please try resaving before refreshing',
    } });
  }
};

function* pushNoteChange(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.pushNoteChange, payload);
    if (response.error) {
      yield put({ type: types.PUSH_NOTE_CHANGE_FAIL, payload: response.error });
    }

    yield put({ type: types.PUSH_NOTE_CHANGE_SUCCESS, payload: response?.pushNoteContentUpdate });
  } catch (err) {
    yield put({ type: types.PUSH_NOTE_CHANGE_FAIL , payload: {
      message: 'Your template could not be saved. Please try resaving before refreshing',
      err,
    } });
  }
};

function* deleteNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.deleteNote, payload);
    if (response.deleteNote.isDeleted) {
      yield put({ type: types.DELETE_NOTE_SUCCESS, payload: { id: payload } });
    } else {
      yield put({ type: types.DELETE_NOTE_FAIL });
    }
  } catch (err) {
    yield put({ type: types.DELETE_NOTE_FAIL });
  }
}

function* createNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.createNoteTemplate, payload);
    yield put({ type: types.CREATE_TEMPLATE_SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: types.CREATE_TEMPLATE_FAIL });
  }
}

function* updateNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.updateNoteTemplate, payload);
    if (response?.updateNoteTemplate?.noteTemplate) {
      yield put({ type: types.UPDATE_TEMPLATE_SUCCESS, payload: response?.updateNoteTemplate?.noteTemplate });
    }
  } catch (err) {
    yield put({ type: types.UPDATE_TEMPLATE_FAIL });
  }
};

function* updateNoteTemplateContent(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateNoteTemplateContent, payload);
    if (response.error) {
      yield put({ type: types.UPDATE_TEMPLATE_CONTENT_FAIL, payload: response.error });
    }

    yield put({ type: types.UPDATE_TEMPLATE_CONTENT_SUCCESS, payload: response?.updateNoteTemplateContent });
  } catch (err) {
    yield put({ type: types.UPDATE_TEMPLATE_FAIL , payload: {
      message: 'Your template could not be saved. Please try resaving before refreshing',
    } });
  }
};

function* pushNoteTemplateChange(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.pushNoteTemplateChange, payload);
    if (response.error) {
      yield put({ type: types.PUSH_NOTE_TEMPLATE_CHANGE_FAIL, payload: response.error });
    }

    yield put({ type: types.PUSH_NOTE_TEMPLATE_CHANGE_SUCCESS, payload: response?.pushNoteTemplateContentUpdate });
  } catch (err) {
    yield put({ type: types.PUSH_NOTE_TEMPLATE_CHANGE_FAIL , payload: {
      message: 'Your template could not be saved. Please try resaving before refreshing',
    } });
  }
};

function* deleteNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.deleteNoteTemplate, payload);
    yield put({ type: types.DELETE_TEMPLATE_SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: types.DELETE_TEMPLATE_FAIL });
  }
}

function* duplicateNoteTemplate(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.duplicateNoteTemplate, payload);
    yield put({
      type: types.DUPLICATE_TEMPLATE_SUCCESS,
      payload: response.data.duplicateNoteTemplate.noteTemplate,
    });
  } catch (err) {
    yield put({ type: types.DUPLICATE_TEMPLATE_FAIL });
  }
}

function* downloadStart() {
  try {
    yield put({ type: types.DOWNLOAD_SUCCESS, payload: {} });
  } catch (err) {
    yield put({ type: types.DOWNLOAD_FAIL });
  }
}

function* updateUseFileUpload(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateUseFileUpload, payload);
    yield put({
      type: types.UPDATE_USE_FILE_UPLOAD_SUCCESS,
      payload: response.useFileUpload.output,
    });
  } catch (err) {
    yield put({ type: types.UPDATE_USE_FILE_UPLOAD_FAIL });
  }
}

function* updateTemplateUseFileUpload(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateUseTemplateFileUpload, payload);
    yield put({
      type: types.UPDATE_USE_TEMPLATE_FILE_UPLOAD_SUCCESS,
      payload: response.useFileTemplateUpload.output,
    });
  } catch (err) {
    yield put({ type: types.UPDATE_USE_TEMPLATE_FILE_UPLOAD_FAIL });
  }
}

export default function* watchList() {
  yield takeLatest(types.GET_CURRENT_NOTE, getNote);
  yield takeLatest(types.BLOCK_NOTE, blockNote);
  yield takeLatest(types.UNBLOCK_NOTE, unBlockNote);
  yield takeLatest(types.NOTE_FILE_UPLOAD, fileUpload);
  yield takeLatest(types.NOTE_FILE_REMOVE, fileRemove);
  yield takeLatest(types.NOTE_TEMPLATE_FILE_REMOVE, templateFileRemove);
  yield takeLatest(types.CREATE_NOTE, createNote);
  yield takeLatest(types.UPDATE_NOTE, updateSingleNote);
  yield takeLatest(types.UPDATE_NOTE_CONTENT, updateNoteContent);
  yield takeLatest(types.PUSH_NOTE_CHANGE, pushNoteChange);
  yield takeLatest(types.DELETE_NOTE, deleteNote);
  yield takeLatest(types.DOWNLOAD_START, downloadStart);
  yield takeLatest(types.GET_NOTE_BLOCKED_STATUS, getNoteBlockedStatus);
  yield takeLatest(types.RESTRICTIONS_NOTE, restrictionsNote);
  yield takeLatest(types.GET_CURRENT_TEMPLATE, getNoteTemplate);
  yield takeLatest(types.CREATE_TEMPLATE, createNoteTemplate);
  yield takeLatest(types.UPDATE_TEMPLATE, updateNoteTemplate);
  yield takeLatest(types.UPDATE_TEMPLATE_CONTENT, updateNoteTemplateContent);
  yield takeLatest(types.PUSH_NOTE_TEMPLATE_CHANGE, pushNoteTemplateChange);
  yield takeLatest(types.DELETE_TEMPLATE, deleteNoteTemplate);
  yield takeLatest(types.DUPLICATE_TEMPLATE, duplicateNoteTemplate);
  yield takeLatest(types.UPDATE_USE_FILE_UPLOAD, updateUseFileUpload);
  yield takeLatest(types.UPDATE_USE_TEMPLATE_FILE_UPLOAD, updateTemplateUseFileUpload);
}
